jQuery(document).ready(function () {
    const communityAssociationOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 8, "h": 8, "c": 1, "r": 1},
            {"w": 5, "h": 5, "c": 1, "r": 9},
            {"w": 3, "h": 6, "c": 6, "r": 6},
            {"w": 3, "h": 5, "c": 6, "r": 12},
            {"w": 5, "h": 5, "c": 1, "r": 14},
        ],
        itemsBaseURL: '/assets/images/markets/community-associations/',
        items: [
            {src: 'community-associations-1-full.jpg', srct: 'community-associations-1.jpg', title: ''},
            {src: 'community-associations-2-full.jpg', srct: 'community-associations-2.jpg', title: ''},
            {src: 'community-associations-3-full.jpg', srct: 'community-associations-3.jpg', title: ''},
            {src: 'community-associations-4-full.jpg', srct: 'community-associations-4.jpg', title: ''},
            {src: 'community-associations-5-full.jpg', srct: 'community-associations-5.jpg', title: ''},
        ]
    };
    const educationOptions = {
        thumbnailHeight: 65,
        thumbnailWidth: 345,
        galleryMosaic: [
            {"w": 2, "h": 6, "c": 1, "r": 1},
            {"w": 1, "h": 6, "c": 1, "r": 7},
            {"w": 1, "h": 3, "c": 2, "r": 6},
            {"w": 1, "h": 3, "c": 2, "r": 9},
        ],
        itemsBaseURL: '/assets/images/markets/education/',
        items: [
            {src: 'education-market-1-full.jpg', srct: 'education-market-1.jpg', title: ''},
            {src: 'education-market-2-full.jpg', srct: 'education-market-2.jpg', title: ''},
            {src: 'education-market-3-full.jpg', srct: 'education-market-3.jpg', title: ''},
            {src: 'education-market-4-full.jpg', srct: 'education-market-4.jpg', title: ''},
        ]
    };
    const governmentOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 345,
        galleryMosaic: [
            {"w": 2, "h": 6, "c": 1, "r": 1},
            {"w": 1, "h": 5, "c": 1, "r": 7},
            {"w": 1, "h": 3, "c": 2, "r": 6},
            {"w": 1, "h": 3, "c": 2, "r": 9},
        ],
        itemsBaseURL: '/assets/images/markets/government/',
        items: [
            {src: 'government-market-1-full.jpg', srct: 'government-market-1.jpg', title: ''},
            {src: 'government-market-2-full.jpg', srct: 'government-market-2.jpg', title: ''},
            {src: 'government-market-3-full.jpg', srct: 'government-market-3.jpg', title: ''},
            {src: 'government-market-4-full.jpg', srct: 'government-market-4.jpg', title: ''},
        ]
    };
    const healthcareOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 345,
        galleryMosaic: [
            {"w": 2, "h": 6, "c": 1, "r": 1},
            {"w": 2, "h": 6, "c": 1, "r": 7},
            {"w": 1, "h": 3, "c": 1, "r": 12},
        ],
        itemsBaseURL: '/assets/images/markets/healthcare/',
        items: [
            {src: 'healthcare-market-1-full.jpg', srct: 'healthcare-market-1.jpg', title: ''},
            {src: 'healthcare-market-2-full.jpg', srct: 'healthcare-market-2.jpg', title: ''},
            {src: 'healthcare-market-3-full.jpg', srct: 'healthcare-market-3.jpg', title: ''},
        ]
    };
    const commercialPropertiesOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 10, "h": 15, "c": 1, "r": 1},
            {"w": 4, "h": 5, "c": 8, "r": 7},
            {"w": 4, "h": 5, "c": 4, "r": 12},
            {"w": 4, "h": 5, "c": 8, "r": 12},
        ],
        itemsBaseURL: '/assets/images/markets/commercial-properties/',
        items: [
            {src: 'commercial-properties-1-full.jpg', srct: 'commercial-properties-1.jpg', title: ''},
            {src: 'commercial-properties-2-full.jpg', srct: 'commercial-properties-2.jpg', title: ''},
            {src: 'commercial-properties-3-full.jpg', srct: 'commercial-properties-3.jpg', title: ''},
            {src: 'commercial-properties-4-full.jpg', srct: 'commercial-properties-4.jpg', title: ''},
        ]
    };
    const industrialOptions = {
        thumbnailHeight: 110,
        thumbnailWidth: 125,
        galleryMosaic: [
            {"w":6, "h": 7, "c": 1, "r": 1},
            {"w": 4, "h": 3, "c": 1, "r": 5},
        ],
        itemsBaseURL: '/assets/images/markets/industrial/',
        items: [
            {src: 'industrial-full-1.jpg', srct: 'industrial-1.jpg', title: ''},
            {src: 'industrial-full-2.jpg', srct: 'industrial-2.jpg', title: ''},
        ]
    };
    const conditionEvaluationsOptions = {
        thumbnailHeight: 80,
        thumbnailWidth: 80,
        galleryMosaic: [
            {"w":8, "h": 8, "c": 1, "r": 1},
            {"w": 3, "h": 5, "c": 1, "r": 2},
            {"w": 4, "h": 3, "c": 1, "r": 7},
            {"w": 4, "h": 4, "c": 1, "r": 9},
            {"w": 4, "h": 4, "c": 5, "r": 9},
        ],
        itemsBaseURL: '/assets/images/services/condition-evaluations/', items: [
            {src: 'condition-evaluation-1-full.jpg', srct: 'condition-evaluation-1.jpg', title: ''},
            {src: 'condition-evaluation-2-full.jpg', srct: 'condition-evaluation-2.jpg', title: ''},
            {src: 'condition-evaluation-3-full.jpg', srct: 'condition-evaluation-3.jpg', title: ''},
            {src: 'condition-evaluation-4-full.jpg', srct: 'condition-evaluation-4.jpg', title: ''},
            {src: 'condition-evaluation-5-full.jpg', srct: 'condition-evaluation-5.jpg', title: ''},
        ]
    };
    const peerReviewOptions = {
        thumbnailHeight: 100,
        thumbnailWidth: 100,
        galleryMosaic: [
            {"w":8, "h": 6, "c": 1, "r": 1},
            {"w": 4, "h": 4, "c": 1, "r": 7},
            {"w": 4, "h": 4, "c": 5, "r": 7},
        ],
        itemsBaseURL: '/assets/images/services/peer-review/', items: [
            {src: 'peer-review-and-commissioning-1-full.jpg', srct: 'peer-review-and-commissioning-1.jpg', title: ''},
            {src: 'peer-review-and-commissioning-2-full.jpg', srct: 'peer-review-and-commissioning-2.jpg', title: ''},
            {src: 'peer-review-and-commissioning-3-full.jpg', srct: 'peer-review-and-commissioning-3.jpg', title: ''},
        ]
    };
    const repairDesignOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 69,
        galleryMosaic: [
            {"w": 10, "h": 10, "c": 1, "r": 1},
            {"w": 5, "h": 5, "c": 6, "r": 6},
            {"w": 5, "h": 5, "c": 1, "r": 11},
            {"w": 5, "h": 5, "c": 6, "r": 11},
        ],
        itemsBaseURL: '/assets/images/services/repair-design/',
        items: [
            {src: 'repair-design-1-full.jpg', srct: 'repair-design-1.jpg', title: ''},
            {src: 'repair-design-2-full.jpg', srct: 'repair-design-2.jpg', title: ''},
            {src: 'repair-design-3-full.jpg', srct: 'repair-design-3.jpg', title: ''},
            {src: 'repair-design-4-full.jpg', srct: 'repair-design-4.jpg', title: ''},
        ]
    };
    const waterproofingOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 69,
        galleryMosaic: [
            {"w": 10, "h": 10, "c": 1, "r": 1},
            {"w": 5, "h": 4, "c": 6, "r": 7},
            {"w": 5, "h": 4, "c": 1, "r": 11},
            {"w": 5, "h": 4, "c": 6, "r": 11},
        ],
        itemsBaseURL: '/assets/images/services/waterproofing/',
        items: [
            {src: 'waterproofing-1-full.jpg', srct: 'waterproofing-1.jpg', title: ''},
            {src: 'waterproofing-2-full.jpg', srct: 'waterproofing-2.jpg', title: ''},
            {src: 'waterproofing-3-full.jpg', srct: 'waterproofing-3.jpg', title: ''},
            {src: 'waterproofing-4-full.jpg', srct: 'waterproofing-4.jpg', title: ''},
        ]
    };
    const specializedDiagnosticTestingOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 69,
        galleryMosaic: [
            {"w": 10, "h": 4, "c": 1, "r": 1},
            {"w": 5, "h": 5, "c": 1, "r": 5},
            {"w": 5, "h": 5, "c": 6, "r": 5},
            {"w": 5, "h": 5, "c": 1, "r": 10},
            {"w": 5, "h": 5, "c": 6, "r": 10},
            {"w": 4, "h": 4, "c": 4, "r": 8},
        ],
        itemsBaseURL: '/assets/images/services/specialized-diagnostic-testing/',
        items: [
            {src: 'specialized-diagnostic-testing-1-full.jpg', srct: 'specialized-diagnostic-testing-1.jpg', title: ''},
            {src: 'specialized-diagnostic-testing-2-full.jpg', srct: 'specialized-diagnostic-testing-2.jpg', title: ''},
            {src: 'specialized-diagnostic-testing-3-full.jpg', srct: 'specialized-diagnostic-testing-3.jpg', title: ''},
            {src: 'specialized-diagnostic-testing-5-full.jpg', srct: 'specialized-diagnostic-testing-5.jpg', title: ''},
            {src: 'specialized-diagnostic-testing-6-full.jpg', srct: 'specialized-diagnostic-testing-6.jpg', title: ''},
            {src: 'specialized-diagnostic-testing-4-full.jpg', srct: 'specialized-diagnostic-testing-4.jpg', title: ''},
        ]
    };
    const hospitalityOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 115,
        galleryMosaic: [
            {"w": 6, "h": 6, "c": 1, "r": 1},
            {"w": 3, "h": 4, "c": 1, "r": 7},
            {"w": 3, "h": 4, "c": 4, "r": 7},
            {"w": 2, "h": 3, "c": 1, "r": 10},
            {"w": 2, "h": 3, "c": 3, "r": 10},
        ],
        itemsBaseURL: '/assets/images/markets/hospitality/',
        items: [
            {src: 'hospitality-market-1-full.jpg', srct: 'hospitality-market-1.jpg', title: ''},
            {src: 'hospitality-market-2-full.jpg', srct: 'hospitality-market-2.jpg', title: ''},
            {src: 'hospitality-market-3-full.jpg', srct: 'hospitality-market-3.jpg', title: ''},
            {src: 'hospitality-market-4-full.jpg', srct: 'hospitality-market-4.jpg', title: ''},
            {src: 'hospitality-market-5-full.jpg', srct: 'hospitality-market-5.jpg', title: ''},
        ]
    };
    const libraryOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 138,
        galleryMosaic: [
            {"w": 5, "h": 5, "c": 1, "r": 1},
            {"w": 3, "h": 4, "c": 1, "r": 6},
            {"w": 2, "h": 3, "c": 4, "r": 5},
            {"w": 2, "h": 3, "c": 4, "r": 8},
        ],
        itemsBaseURL: '/assets/images/markets/library/',
        items: [
            {src: 'library-market-1-full.jpg', srct: 'library-market-1.jpg', title: ''},
            {src: 'library-market-2-full.jpg', srct: 'library-market-2.jpg', title: ''},
            {src: 'library-market-3-full.jpg', srct: 'library-market-3.jpg', title: ''},
            {src: 'library-market-4-full.jpg', srct: 'library-market-4.jpg', title: ''},
        ]
    };
    const retailOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 138,
        galleryMosaic: [
            {"w": 5, "h": 5, "c": 1, "r": 1},
            {"w": 3, "h": 5, "c": 1, "r": 6},
            {"w": 2, "h": 3, "c": 4, "r": 5},
            {"w": 2, "h": 3, "c": 4, "r": 8},
        ],
        itemsBaseURL: '/assets/images/markets/retail/',
        items: [
            {src: 'retail-market-1-full.jpg', srct: 'retail-market-1.jpg', title: ''},
            {src: 'retail-market-2-full.jpg', srct: 'retail-market-2.jpg', title: ''},
            {src: 'retail-market-3-full.jpg', srct: 'retail-market-3.jpg', title: ''},
            {src: 'retail-market-4-full.jpg', srct: 'retail-market-4.jpg', title: ''},
        ]
    };
    const religiousOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 100,
        galleryMosaic: [
            {"w": 7, "h": 7, "c": 1, "r": 1},
            {"w": 3, "h": 4, "c": 5, "r": 5},
            {"w": 4, "h": 5, "c": 1, "r": 6},
            {"w": 4, "h": 3, "c": 4, "r": 9},
        ],
        itemsBaseURL: '/assets/images/markets/religious-facilities/',
        items: [
            {src: 'religious-facilities-1-full.jpg', srct: 'religious-facilities-1.jpg', title: ''},
            {src: 'religious-facilities-2-full.jpg', srct: 'religious-facilities-2.jpg', title: ''},
            {src: 'religious-facilities-3-full.jpg', srct: 'religious-facilities-3.jpg', title: ''},
            {src: 'religious-facilities-4-full.jpg', srct: 'religious-facilities-4.jpg', title: ''},
        ]
    };
    const buildingFacadeOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 69,
        galleryMosaic: [
            {"w": 10, "h": 9, "c": 1, "r": 1},
            {"w": 5, "h": 3, "c": 1, "r": 6},
            {"w": 6, "h": 5, "c": 1, "r": 9},
            {"w": 4, "h": 5, "c": 7, "r": 10},
        ],
        itemsBaseURL: '/assets/images/expertise/building-facades/',
        items: [
            {src: 'building-facades-1-full.jpg', srct: 'building-facades-1.jpg', title: ''},
            {src: 'building-facades-2-full.jpg', srct: 'building-facades-2.jpg', title: ''},
            {src: 'building-facades-3-full.jpg', srct: 'building-facades-3.jpg', title: ''},
            {src: 'building-facades-4-full.jpg', srct: 'building-facades-4.jpg', title: ''},
        ]
    };
    const parkingGarageOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 69,
        galleryMosaic: [
            {"w": 10, "h": 8, "c": 1, "r": 1},
            {"w": 5, "h": 3, "c": 1, "r": 7},
            {"w": 5, "h": 3, "c": 6, "r": 8},
            {"w": 6, "h": 5, "c": 1, "r": 10},
            {"w": 4, "h": 5, "c": 7, "r": 11},
        ],
        itemsBaseURL: '/assets/images/expertise/parking-garages/',
        items: [
            {src: 'parking-garages-1-full.jpg', srct: 'parking-garages-1.jpg', title: ''},
            {src: 'parking-garages-2-full.jpg', srct: 'parking-garages-2.jpg', title: ''},
            {src: 'parking-garages-3-full.jpg', srct: 'parking-garages-3.jpg', title: ''},
            {src: 'parking-garages-4-full.jpg', srct: 'parking-garages-4.jpg', title: ''},
            {src: 'parking-garages-5-full.jpg', srct: 'parking-garages-5.jpg', title: ''},
        ]
    };
    const historicPreservationOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 6, "h": 10, "c": 1, "r": 1},
            {"w": 6, "h": 5, "c": 1, "r": 10},
            {"w": 4, "h": 7, "c": 7, "r": 1},
            {"w": 4, "h": 7, "c": 7, "r": 8},
        ],
        itemsBaseURL: '/assets/images/expertise/historic-preservation/',
        items: [
            {src: 'historic-preservation-1-full.jpg', srct: 'historic-preservation-1.jpg', title: ''},
            {src: 'historic-preservation-2-full.jpg', srct: 'historic-preservation-2.jpg', title: ''},
            {src: 'historic-preservation-3-full.jpg', srct: 'historic-preservation-3.jpg', title: ''},
            {src: 'historic-preservation-4-full.jpg', srct: 'historic-preservation-4.jpg', title: ''},
        ]
    };
    const roofingOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 8, "h": 6, "c": 1, "r": 1},
            {"w": 4, "h": 3, "c": 1, "r": 6},
            {"w": 4, "h": 3, "c": 5, "r": 7},
            {"w": 5, "h": 5, "c": 1, "r": 9},
            {"w": 3, "h": 5, "c": 6, "r": 10},
        ],
        itemsBaseURL: '/assets/images/expertise/roofing/',
        items: [
            {src: 'roofing-1-full.jpg', srct: 'roofing-1.jpg', title: ''},
            {src: 'roofing-2-full.jpg', srct: 'roofing-2.jpg', title: ''},
            {src: 'roofing-3-full.jpg', srct: 'roofing-3.jpg', title: ''},
            {src: 'roofing-4-full.jpg', srct: 'roofing-4.jpg', title: ''},
            {src: 'roofing-5-full.jpg', srct: 'roofing-5.jpg', title: ''},
        ]
    };
    const structuralDistressOptions = {
        thumbnailHeight: 70,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 10, "h": 6, "c": 1, "r": 1},
            {"w": 5, "h": 3, "c": 1, "r": 7},
            {"w": 5, "h": 3, "c": 6, "r": 7},
            {"w": 6, "h": 3, "c": 1, "r": 10},
            {"w": 4, "h": 3, "c": 7, "r": 10},
        ],
        itemsBaseURL: '/assets/images/expertise/structural-distress/',
        items: [
            {src: 'structural-distress-1-full.jpg', srct: 'structural-distress-1.jpg', title: ''},
            {src: 'structural-distress-2-full.jpg', srct: 'structural-distress-2.jpg', title: ''},
            {src: 'structural-distress-3-full.jpg', srct: 'structural-distress-3.jpg', title: ''},
            {src: 'structural-distress-4-full.jpg', srct: 'structural-distress-4.jpg', title: ''},
            {src: 'structural-distress-5-full.jpg', srct: 'structural-distress-5.jpg', title: ''},
        ]
    };
    const constructionPhaseOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 8, "h": 10, "c": 1, "r": 1},
            {"w": 3, "h": 6, "c": 1, "r": 2},
            {"w": 4, "h": 3, "c": 1, "r": 7},
            {"w": 4, "h": 5, "c": 1, "r": 10},
            {"w": 4, "h": 5, "c": 5, "r": 10},
        ],
        itemsBaseURL: '/assets/images/services/construction-phase/',
        items: [
            {src: 'construction-phase-1-full.jpg', srct: 'construction-phase-1.jpg', title: ''},
            {src: 'construction-phase-2-full.jpg', srct: 'construction-phase-2.jpg', title: ''},
            {src: 'construction-phase-3-full.jpg', srct: 'construction-phase-3.jpg', title: ''},
            {src: 'construction-phase-4-full.jpg', srct: 'construction-phase-4.jpg', title: ''},
            {src: 'construction-phase-5-full.jpg', srct: 'construction-phase-5.jpg', title: ''},
        ]
    };
    const transitionOptions = {
        thumbnailHeight: 60,
        thumbnailWidth: 86,
        galleryMosaic: [
            {"w": 4, "h": 10, "c": 1, "r": 1},
            {"w": 4, "h": 5, "c": 5, "r": 1},
            {"w": 4, "h": 4, "c": 5, "r": 6},
            {"w": 8, "h": 4, "c": 1, "r": 11},
        ],
        itemsBaseURL: '/assets/images/services/transition-and-capital-asset-studies/',
        items: [
            {src: 'transition-1-full.jpg', srct: 'transition-1-v2.jpg', title: ''},
            {src: 'transition-2-full.jpg', srct: 'transition-2.jpg', title: ''},
            {src: 'transition-3-full.jpg', srct: 'transition-3.jpg', title: ''},
            {src: 'transition-4-full.png', srct: 'transition-4.png', title: ''},
        ]
    };
    const whatWeDoOptions = {
        thumbnailHeight: 70,
        thumbnailWidth: 70,
        galleryMosaic: [
            {"w": 10, "h": 12, "c": 1, "r": 1},
            {"w": 4, "h": 5, "c": 7, "r": 1},
            {"w": 3, "h": 3, "c": 3, "r": 11},
            {"w": 5, "h": 3, "c": 6, "r": 10},
            {"w": 3, "h": 3, "c": 6, "r": 13},
        ],
        itemsBaseURL: '/assets/images/about/what-we-do/',
        items: [
            {src: 'what-we-do-1-full.jpg', srct: 'what-we-do-1.jpg', title: ''},
            {src: 'what-we-do-2-full.jpg', srct: 'what-we-do-2.jpg', title: ''},
            {src: 'what-we-do-3-full.jpg', srct: 'what-we-do-3.jpg', title: ''},
            {src: 'what-we-do-4-full.jpg', srct: 'what-we-do-4.jpg', title: ''},
            {src: 'what-we-do-5-full.jpg', srct: 'what-we-do-5.jpg', title: ''},
        ]
    };
    const ourMissionOptions = {
        thumbnailHeight: 70,
        thumbnailWidth: 70,
        galleryMosaic: [
            {"w": 6, "h": 8, "c": 1, "r": 1},
            {"w": 4, "h": 4, "c": 7, "r": 1},
            {"w": 4, "h": 4, "c": 7, "r": 5},
            {"w": 6, "h": 4, "c": 5, "r": 9},
            {"w": 4, "h": 4, "c": 1, "r": 9},
        ],
        itemsBaseURL: '/assets/images/about/our-mission/',
        items: [
            {src: 'our-mission-1-full.jpg', srct: 'our-mission-1.jpg', title: ''},
            {src: 'our-mission-2-full.jpg', srct: 'our-mission-2.jpg', title: ''},
            {src: 'our-mission-3-full.jpg', srct: 'our-mission-3.jpg', title: ''},
            {src: 'our-mission-4-full.jpg', srct: 'our-mission-4.jpg', title: ''},
            {src: 'our-mission-5-full.jpg', srct: 'our-mission-5.jpg', title: ''},
        ]
    };
    const clientBenefitsOptions = {
        thumbnailHeight: 70,
        thumbnailWidth: 350,
        galleryMosaic: [
            {"w": 2, "h": 8, "c": 1, "r": 1},
            {"w": 1, "h": 3, "c": 1, "r": 9},
            {"w": 1, "h": 3, "c": 2, "r": 9},
        ],
        itemsBaseURL: '/assets/images/about/client-benefits/',
        items: [
            {src: 'client-benefits-full-1.jpg', srct: 'client-benefits-1.jpg', title: ''},
            {src: 'client-benefits-full-2.jpg', srct: 'client-benefits-2.jpg', title: ''},
            {src: 'client-benefits-full-3.jpg', srct: 'client-benefits-3.jpg', title: ''},
        ]
    };
    const collages = {
        // services:
        construction: constructionPhaseOptions,
        transition: transitionOptions,
        'condition-evaluation': conditionEvaluationsOptions,
        'peer-review': peerReviewOptions,
        'repair-design': repairDesignOptions,
        waterproofing: waterproofingOptions,
        'specialized-diagnostic-testing': specializedDiagnosticTestingOptions,
        // markets:
        community: communityAssociationOptions,
        education: educationOptions,
        government: governmentOptions,
        healthcare: healthcareOptions,
        hospitality: hospitalityOptions,
        libraries: libraryOptions,
        retail: retailOptions,
        industrial: industrialOptions,
        'commercial-properties': commercialPropertiesOptions,
        'religious-facilities': religiousOptions,
        // expertise:
        facades: buildingFacadeOptions,
        parking: parkingGarageOptions,
        historic: historicPreservationOptions,
        roofing: roofingOptions,
        'structural-distress': structuralDistressOptions,
        // about:
        'what-we-do': whatWeDoOptions,
        'our-mission': ourMissionOptions,
        'client-benefits': clientBenefitsOptions
    }
    let options;
    for (let i = 0; i < Object.getOwnPropertyNames(collages).length; i++) {
        const collage = Object.getOwnPropertyNames(collages)[i];
        if (window.location.pathname.indexOf(collage) !== -1) {
            options = collages[collage];
            break;
        }
    }
    if (!options) return;

    $("#nanogallery2").nanogallery2({
        thumbnailHeight: options.thumbnailHeight,
        thumbnailWidth: options.thumbnailWidth,
        galleryMosaic: options.galleryMosaic,
        thumbnailGutterWidth: 7,
        thumbnailGutterHeight: 7,
        thumbnailBorderHorizontal: 0,
        thumbnailBorderVertical: 0,
        galleryDisplayMode: "fullContent",
        itemsBaseURL: options.itemsBaseURL,
        locationHash: true,
        thumbnailLabel: {"display": false},
        items: options.items
    });
});